import { User } from "@/schemas/User"
import { useCourseStore } from "@/store/courseStoreProvider"
import { resolveUserLicenseType } from "@/utils/user/resolveUserLicenseType"
import { resolveUserStatus } from "@/utils/user/resolveUserStatus"

export function useSetCurrentUser() {
  const update = useCourseStore((s) => s.update)

  function updateUser(user: null | User) {
    update({
      user: user,
      userStatus: resolveUserStatus(user),
      licenseType: resolveUserLicenseType(user),
      lastViewedSectionUuid: user?.account.lastViewedSectionUuid || null,
    })
  }

  return updateUser
}
